import apiSettings from '../../config/api';
import request from '../../utils/request/index';
import actionTypes from './ActioTypes';

const getTours = (data) => {
  const url = apiSettings.endpoints.genGetToursUrl();
  return dispatch => {
    request
      .post(url, data, dispatch, actionTypes.GET_TOURS)
      .then((res) => {
        dispatch({type: actionTypes.GET_TOURS.fulfilled, data: res.data});
        dispatch({type: actionTypes.SET_SEARCH_CITY, data: data.cityId});
      })
  }
};

const filterByDateOff = (dayOff, date) => {
  for (let j = 0; j < dayOff.length; j++) {
    if (dayOff[j] === date.format("YYYY-MM-DD")) {
      return false;
    }
  }
  return true;
};

const filterByDate = (tourDates, date) => {
  for (let j = 0; j < tourDates.length; j++) {
    if (tourDates[j].weakDay === (date.isoWeekday() - 1)) {
      return true;
    }
  }
  return false;
};

const filterByCategories = (categoriesId, categoryId) => {
  for (let k = 0; k < categoriesId.length; k++) {
    if (categoryId === categoriesId[k]) {
      return true;
    }
  }
  return false;
};

const onFilterTours = (categoriesId, peoples, date) => {
  return (dispatch, getState) => {
    const tours = [...getState().searchResult.tours];
    let othersTours = tours;
    const filterTours = [];

    for (let i = 0; i < tours.length; i++) {
      let isAdded = false;
      let isContinue = false;
      // By date
      if (date && tours[i].dayOff && tours[i].tourDates) {
        // Filter By Days Off
        isAdded = filterByDateOff(tours[i].dayOff, date);
        // console.log('TETS 123', isAdded, tours[i].priceOnePerson)
        if(!isAdded) {
          isContinue = true;
        }
        // Filter By Date
        if (!isAdded && !isContinue)
          isAdded = filterByDate(tours[i].tourDates, date);
        if(!isAdded) {
          isContinue = true;
        }
      }

      // Filter By Category;
      if (categoriesId.length > 0 && !isContinue) {
        isAdded = filterByCategories(categoriesId, tours[i].categoryId);
        if (!isAdded)
          isContinue = true;
      }
      // Filter By People
      if (peoples && !isContinue) {
        if (peoples >= tours[i].minPersons && peoples <= tours[i].maxPersons) {
          isAdded = true;
        } else {
          isAdded = false
        }
      }

      if (isAdded) {
        filterTours.push(tours[i]);
      }
    }

    // Clean OtherTours state
    if (filterTours.length > 0) {
      for (let i = 0; i < filterTours.length; i++) {
        for (let k = 0; k < othersTours.length; k++) {
          if (othersTours[k].id === filterTours[i].id) {
            othersTours.splice(k, 1)
          }
        }
      }
    } else {
      othersTours = tours
    }

    dispatch({type: actionTypes.FILTER_TOURS, data: {filterTours, othersTours}});
  }
};

const searchPageUnMounted = () => {
  return dispatch => {
    dispatch({type: actionTypes.UN_MOUNTED})
  }
};

export {getTours, onFilterTours, searchPageUnMounted}


// WEBPACK FOOTER //
// ./src/app/containers/SearchResult/Actions.js